import { SuccessNotification, Text } from '@epam/loveship'
import { CommonContexts, UuiContexts } from '@epam/uui-core'
import { showNotification } from './showNotification'

export const showSuccessNotification = ({
  svc,
  message,
}: {
  svc: CommonContexts<UuiContexts, any>
  message: string
}) => {
  showNotification(svc, (props) => (
    <SuccessNotification {...props}>
      <Text>{message}</Text>
    </SuccessNotification>
  ))
}
